
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit-cards",
      function () {
        return require("private-next-pages/credit-cards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit-cards"])
      });
    }
  